import {IconButton} from '@mui/material'
import PropTypes from 'prop-types'

import DashboardHeading from '../shared_components/mui_base_components/dashboard_heading/DashboardHeading'

import CaretIcon from './CaretIcon'

import './carouselControls.scss'

const CarouselControls = props => {
  const {
    currentCarouselIndex,
    next,
    previous,
    numberOfSlides,
    title
  } = props

  return (
    <div className='carousel-controls'>
      <DashboardHeading>{title}</DashboardHeading>
      <div className={`buttons-container slide-count-${numberOfSlides}`}>
        <IconButton
          aria-label='previous-button'
          className='previous'
          color='primary'
          disabled={currentCarouselIndex === 0}
          onClick={previous}>
          <CaretIcon />
        </IconButton>
        <IconButton
          aria-label='next-button'
          className='next'
          color='primary'
          disabled={currentCarouselIndex + 2 === numberOfSlides}
          onClick={next}>
          <CaretIcon />
        </IconButton>
      </div>
    </div>
  )
}

CarouselControls.propTypes = {
  currentCarouselIndex: PropTypes.number.isRequired,
  next: PropTypes.func.isRequired,
  previous: PropTypes.func.isRequired,
  numberOfSlides: PropTypes.number.isRequired,
  title: PropTypes.string
}

export default CarouselControls
